import React from "react";
import { useFieldLookup } from "../../../../hooks/useFieldLookup";
import { usersCachingService } from "../../../../services";
import { Flagged } from "./Flagged";
import { Divider, Grid, Typography } from "@material-ui/core";
import { ActivitySkeleton } from "./ActivitySkeleton";
import { useIsReady } from "../../../../hooks/useIsReadyHook";
import { mapFromCamelCase, renderMetaChange } from "../../EditReasonDialog";
export const CaseEdit = ({ model, onToggle, disabled, onIsReady }) => {
    const { eventMeta } = model;
    const createdByName = useFieldLookup(usersCachingService, model.createdBy);
    const isReady = createdByName;
    useIsReady(!!isReady, onIsReady);
    return !isReady ? (React.createElement(ActivitySkeleton, null)) : (React.createElement("div", null,
        React.createElement(Flagged, { title: model.flagged ? "Mark as unflagged" : "Mark as flagged", isFlagged: model.flagged, onClick: () => onToggle(), disabled: disabled, hook: "activity-togglee-" + (model.flagged ? "true" : "false") }),
        React.createElement(Typography, { "data-test": "activity-title" },
            React.createElement("strong", null, createdByName),
            " edited case"),
        React.createElement(Divider, null),
        React.createElement("div", { "data-test": "activity-body" },
            eventMeta.changes &&
                eventMeta.changes.map((change) => (React.createElement("div", { key: change.field },
                    React.createElement("h3", { "data-test": "activity-field-title" }, mapFromCamelCase(change.field)),
                    React.createElement("div", null,
                        React.createElement(Grid, { container: true, spacing: 3 },
                            React.createElement(Grid, { item: true },
                                React.createElement("b", null, "Old value:")),
                            React.createElement(Grid, { item: true, md: 1 }, renderMetaChange(change.field, change.oldValue)),
                            React.createElement(Grid, { item: true },
                                React.createElement("b", null, "New value:")),
                            React.createElement(Grid, { item: true, md: 1 }, renderMetaChange(change.field, change.newValue))))))),
            React.createElement(Typography, { variant: "body1", className: "ActivityNote" },
                "Reason: ",
                eventMeta.reason),
            React.createElement(Typography, { variant: "body1", className: "ActivityNote" },
                "Note: ",
                eventMeta.note))));
};
